<template>
  <div
    class="list-header"
    id="toplist"
    :class="{ act: selectedCount, a1: showA1 }"
  >
    <div
      class="item-header"
      :class="[
        { 'item-check-header-selected': selectedCount },
        { 'item-check-header-no-selected': !selectedCount },
      ]"
    >
      <div class="checkbox" @click="toggleSelectAll">
        <i class="ti-check"></i>
      </div>
      <div
        class="item-selected-number"
        style="display: block"
        v-if="selectedCount"
      >
        已选择{{ selectedCount }}项
      </div>
    </div>

    <div
      v-for="header in headers"
      :key="header.id"
      class="item-header"
      :class="'item-' + header.class + '-header'"
      v-show="!selectedCount && (isList || header.id === 1)"
      @click="sortByHeader(header.id)"
    >
      <div class="file-icon" v-show="header.id === 1">
        <i class="fa fa-file-o"></i>
      </div>
      <p>{{ header.title }}</p>
      <span class="sort" :class="header.sort" v-show="header.showSort"></span>
    </div>

    <div class="item-header item-menu-header" v-if="!selectedCount">
      <p></p>
    </div>
    <div class="item-selected-menu" style="display: block" v-if="selectedCount">
      <a @click="handleSaveSelected" v-if="right__share_saveResource && (showOnShareme || showOnGroupShare)">
        <i class="ti-harddrives"></i>
        保存到
      </a>
      <a
        v-if="isFiles && (showOnSharefile || showOnGroupSend)"
        @click="downloadSelecteds"
      >
        <i class="ti-download"></i>
        下载
      </a>
      <a
        v-if="isFiles && (showOnShareme || showOnGroupShare)"
        @click="downloadShareSelecteds"
      >
        <i class="ti-download"></i>
        下载
      </a>
      <a
        data-toggle="modal"
        data-target="#complaint2"
        v-if="right__share_resource_report_create && isFiles && (showOnShareme || showOnGroupShare)"
      >
        <i class="iconfont icon-jvbao"></i>
        举报
      </a>
    </div>
  </div>
</template>

<script>
import { download } from "@/api/drive/drive";
import { shareDownload } from "@/api/share/share";
export default {
  name: "TableHeaderShareResource",
  components: {},
  props: {
    isList: Boolean,
  },
  data() {
    return {
      showA1: false,
      headers: [
        {
          id: 1,
          title: "名称",
          class: "name",
          sort: "des",
          showSort: false,
          field: {
            "persona-sharefile": "share_title",
            sharefile: "name",
            shareme: "name",
            "group-share": "name",
            "groupdisk-share": "name",
            "group-send": "name",
            "groupdisk-send": "name",
          },
        },
        {
          id: 2,
          title: "大小",
          class: "size",
          sort: "des",
          showSort: false,
          field: "bytes",
        },
        {
          id: 3,
          title: "修改日期",
          class: "time",
          sort: "des",
          showSort: true,
          field: "last_update_date",
        },
        {
          id: 4,
          title: "创建人",
          class: "author",
          sort: "des",
          showSort: false,
          field: "creater_user_real_name",
        },
      ],
    };
  },
  created() {
    this.$store.commit("setSortBy", Object.assign({}, this.headers[0]));
  },
  computed: {
    right__share_resource_report_create() {
      return this.$store.getters.right__share_resource_report_create
    },
    right__share_saveResource() {
      return this.$store.getters.right__share_saveResource
    },
    share() {
      return this.$store.state.drive.share;
    },
    isFiles() {
      return this.$store.state.drive.selectedDatas.every(
        (item) => item.type === "file"
      );
    },
    selectedDatas() {
      return this.$store.state.drive.selectedDatas;
    },
    groupNumber() {
      return this.$store.state.drive.groupNumber;
    },
    tab() {
      return this.$store.state.drive.tab;
    },
    selectedCount() {
      return this.$store.state.drive.selectedDatas.length;
    },
    showOnSharefile() {
      return this.tab === "sharefile" || this.tab === "persona-sharefile";
    },
    showOnShareme() {
      return this.tab === "shareme";
    },
    showOnGroupShare: function () {
      return this.tab === "group-share" || this.tab === "groupdisk-share";
    },
    showOnGroupSend: function () {
      return this.tab === "group-send" || this.tab === "groupdisk-send";
    },
  },
  methods: {
    handleSaveSelected() {
      let lockFile = this.selectedDatas.find(
        (item) => item.is_lock || item.review_status === "block"
      );
      if (lockFile && lockFile.is_lock) {
        this.$message({
          type: "warning",
          message: `文件【${lockFile.name}】已被锁定，锁定原因：${lockFile.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      if (lockFile && lockFile.review_status === "block") {
        this.$message({
          type: "warning",
          message: `该文件因未通过内容审核，已被锁定。如需解锁，请联系管理员`,
        });
        return false;
      }
      this.$emit("handleSaveSelected");
    },
    downloadSelecteds() {
      let lockFile = this.selectedDatas.find(
        (item) => item.is_lock || item.review_status === "block"
      );
      if (lockFile && lockFile.is_lock) {
        this.$message({
          type: "warning",
          message: `文件【${lockFile.name}】已被锁定，锁定原因：${lockFile.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      if (lockFile && lockFile.review_status === "block") {
        this.$message({
          type: "warning",
          message: `该文件因未通过内容审核，已被锁定。如需解锁，请联系管理员`,
        });
        return false;
      }
      if (this.selectedCount > 1) {
        this.$confirm({
          type: "confirm",
          content: `确定批量下载这${this.selectedCount}个文件吗？`,
          showCancleBtn: true,
          showYesBtn: true,
          custom: [],
        })
          .then(() => {
            this.downloadSelectedsByStep();
          })
          .catch(() => {});
      } else {
        this.downloadSelectedsByStep();
      }
    },
    downloadSelectedsByStep() {
      this.selectedDatas.map((data) => {
        download({
          files_list: [data.number],
          group_number: this.groupNumber,
        })
          .then((res) => {
            if (res.status_code === 200) {
              const iframe = window.document.createElement("iframe");
              iframe.style.display = "none";
              iframe.style.height = 0;
              iframe.src = res.entity[data.number] + "&download=download";
              document.body.appendChild(iframe);
              // 10s之后删除
              setTimeout(() => {
                iframe.remove();
              }, 10000);
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      });
    },
    downloadShareSelecteds() {
      let lockFile = this.selectedDatas.find(
        (item) => item.is_lock || item.review_status === "block"
      );
      if (lockFile && lockFile.is_lock) {
        this.$message({
          type: "warning",
          message: `文件【${lockFile.name}】已被锁定，锁定原因：${lockFile.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      if (lockFile && lockFile.review_status === "block") {
        this.$message({
          type: "warning",
          message: `该文件因未通过内容审核，已被锁定。如需解锁，请联系管理员`,
        });
        return false;
      }
      if (this.selectedCount > 1) {
        this.$confirm({
          type: "confirm",
          content: `确定批量下载这${this.selectedCount}个文件吗？`,
          showCancleBtn: true,
          showYesBtn: true,
          custom: [],
        })
          .then(() => {
            this.downloadShareSelectedsByStep();
          })
          .catch(() => {});
      } else {
        this.downloadShareSelectedsByStep();
      }
    },
    downloadShareSelectedsByStep() {
      this.selectedDatas.map((data) => {
        let params = {
          share_number: this.share.share_number,
          share_resources_list: [data.number],
        };
        shareDownload(params)
          .then((res) => {
            if (res.status_code === 200) {
              const iframe = window.document.createElement("iframe");
              iframe.style.display = "none";
              iframe.style.height = 0;
              iframe.src = res.entity[data.number] + "&download=download";
              document.body.appendChild(iframe);
              // 10s之后删除
              setTimeout(() => {
                iframe.remove();
              }, 10000);
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      });
    },
    sortByHeader(id) {
      let that = this;
      this.headers.map(function (item) {
        if (item.id === id) {
          item.showSort = true;
          item.sort = item.sort === "des" ? "asc" : "des";
          that.$store.commit("setSortBy", Object.assign({}, item));
          return item;
        }
        item.showSort = false;
        item.sort = "des";
        return item;
      });
      this.$store.commit("sortByHeader");
    },
    toggleSelectAll() {
      this.$store.commit("toggleSelectAll");
    },
  },
  mounted() {
    if (this.$store.state.drive.drive === "persona") {
      return false;
    }
    let that = this;
    /*滚动停留*/
    let toplist_height = $("#toplist").offset().top; //获取div1的高度
    //滚动处理div
    $(window).scroll(function () {
      let this_scrollTop = $(this).scrollTop();
      if (this_scrollTop > toplist_height) {
        // $("#toplist").addClass("a1");
        that.showA1 = true;
      }
      if (this_scrollTop < toplist_height) {
        // $("#toplist").removeClass("a1");
        that.showA1 = false;
      }
    });
  },
};
</script>

<style scoped>
.a1 .item-selected-menu {
  right: 20px;
}
.a1 {
  width: 1140px !important;
  position: fixed !important;
  top: 0;
  background: #f9f9f9;
  left: 50%;
  margin-left: -570px;
  height: 40px !important;
  z-index: 1000;
  box-shadow: rgba(0, 0, 0, 0.1) 0 0 10px;
}
</style>